<template>
  <div id="page-forms">
    <v-container fluid>
      <v-form
        v-model="form.valid"
        ref="holidayform"
        lazy-validation
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            lg4
            sm4
          >
            <v-text-field
              label="Calendar Year"
              placeholder=""
              prepend-icon="event"
              v-model="form.calendarYear"
              ref="name"
              mask="####"
            ></v-text-field>
          </v-flex>

          <v-flex
            lg4
            sm4
          >
            <!-- <v-autocomplete :items="countries" v-model="form.countries" prepend-icon="assistant" label="Countries" color="blue" item-text="name" item-value="id"></v-autocomplete> -->
            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loader"
              chips
              editable
              flat
              placeholder="Select only suggested Country"
              :items="countryItems"
              v-model="form.countryID"
              prepend-icon="assistant"
              label="Country"
              color="blue"
              item-text="name"
              item-value="countryID"
              @change="stateSelect"
            ></v-autocomplete>
          </v-flex>

          <v-flex
            lg4
            sm4
          >
            <!-- <v-select :items="states" v-model="form.states" prepend-icon="assistant" label="States" color="blue" item-text="name" item-value="id"></v-select> -->
            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loader"
              chips              
              flat
              placeholder="Select only suggested State"
              :items="filterStateItems"
              v-model="form.stateID"
              prepend-icon="assistant"
              label="State"
              color="blue"
              item-text="name"
              item-value="stateID"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <v-text-field
              label="Min Number of Holiday"
              prepend-icon="panorama"
              v-model="form.noOfHolidays"
              mask="###"
            ></v-text-field>
          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loader"
              chips              
              flat
              placeholder="Select only suggested Reference"
              :items="referenceItems"
              v-model="form.reference"
              prepend-icon="assistant"
              label="Reference"
              color="blue"
              item-text="name"
              item-value="name"
            ></v-autocomplete>

          </v-flex>
          <v-flex
            lg4
            sm2
          >

            <v-autocomplete
              v-model="form.statusCodeID"
              label="Status"
              auto
              chips
              prepend-icon="sync"
              :items="statusOptions"
              required
              :rules="form.requiredfield"
            ></v-autocomplete>
          </v-flex>
          <v-flex>
            <holiday-gazetted-information ref="holidayListform"></holiday-gazetted-information>
          </v-flex>
        </v-layout>

      </v-form>
    </v-container>
  </div>
</template>
 
<script>
// import HolidayCompanyAdditional from '@/pages/calendar/HolidayCompanyAdditional';
// import HolidayCompanyInformation from '@/pages/calendar/HolidayCompanyInformation';
import HolidayGazettedInformation from '@/pages/calendar/HolidayGazettedInformation';
//import VWidget from '@/components/VWidget';
import { getStates, getCountries } from '@/api/state';

export default {
  components: {
    // VWidget,
    // HolidayCompanyAdditional,
    // HolidayCompanyInformation,
    HolidayGazettedInformation
  },

  data: () => ({
    items: [
      { title: 'Print' },
      { title: 'More..' },
    ],
    referenceItems: [
      { id: 1, name: 'Temperature Mapping - Report- Intermediate Room (Granule)' },
      { id: 2, name: 'Temperature Mapping - Report (Chiller) - TMP-18-02' },
      { id: 3, name: 'PQ - ZP33 Tablet Press Machine' },
      { id: 4, name: 'PQ - Kobelco Compressed Air System (KS45A)' },
    ],
    stateItems: [],
    countryItems: [],
    filterStateItems: [],
    statusOptions: [
      { text: 'New', value: 201 },
      { text: 'Certified', value: 202 },
      { text: 'Under Development', value: 203 },
      { text: 'Closed', value: 204 }
    ],

    loader: false,
    SDateMenu: false,
    SDate: null,
    TimeMenu: false,
    Time: null,

    allowearlyrelease: [
      {
        id: 0,
        name: 'Select the Allow Early Release'
      },
      {
        id: 1,
        name: 'Yes'
      },
      {
        id: 2,
        name: 'No'
      },
      {
        id: 3,
        name: 'Possible'
      }
    ],

    earlyrelease: [
      {
        id: 0,
        name: 'Select the Early Release'
      },
      {
        id: 1,
        name: 'Yes'
      },
      {
        id: 2,
        name: 'No'
      },
      {
        id: 3,
        name: 'Possible'
      }
    ],
    form: {
      valid: false,
      companyHolidayId: -1,
      calendarYear: 2018,
      loginUser: 'Arun',
      isLogin: 'yes-1',
      plantId: null,
      stateID: -1,
      stateName: '',
      countryID: -1,
      countryName: '',
      noOfHolidays: null,
      reference: -1,
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      companyHolidayDetail: []
    }
  }),
  mounted () {
    this.$validator.localize('en', this.dictionary);
  },
  posts () {
    return getPost();
  },

  methods: {
    initialize () {
      this.loader = true;
      getStates('')
        .then(response2 => {
          this.stateItems = response2.data;
          this.loader = false;
          //this.total = response.data.length;
        })
        .catch(error => {
          this.loader = false;
           window.getApp.$emit('APP_API_ERROR', error);
        });
      getCountries('')
        .then(response3 => {
          this.countryItems = response3.data;
          this.loader = false;
          //this.total = response.data.length;
        })
        .catch(error => {
          this.loader = false;
           window.getApp.$emit('APP_API_ERROR', error);
        });
    },

    handleClick: e => {
      console.log(e);
    },
    submit () {
      this.$validator.validateAll();
    },
    clear () {
      this.form = {};
      this.$validator.reset();
    },
    stateSelect (value) {
      let uom = this.stateItems.filter(o => o.countryID == value);
      this.filterStateItems = uom;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/calendar/Holiday.vue